module.exports = __webpack_public_path__ + "static/media/portfolio1 (39).4e5e3c70.jpeg";